import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { UserPreview, useUserBusinessCardAtom } from '@bizzabo/entities';

import UserProfile from '../../../components/UserProfile';
import useTypeTracking from '../../../../analytics';

interface UserBadgeActionProps {
    user: UserPreview;
    isDisabled?: boolean;
    hasNotification?: boolean;
}

const UserBadgeAction: React.FC<UserBadgeActionProps> = ({
    user,
    isDisabled,
    hasNotification,
    children,
}) => {
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();
    const { openUserIdPopup } = useUserBusinessCardAtom();

    const showUserPopup = props => {
        openUserIdPopup(props);
        trackClickEvent({
            subCategory: 'PROFILE_CLICK',
            description: {
                location: 'MEETING_WIZARD',
                attendee_id: props.id,
            },
        });
    };

    if (!user) {
        return null;
    }

    return (
        <div className={classes.row}>
            <UserProfile
                user={user}
                titleVariant="t71"
                descriptionVariant="t81"
                showUserPopup={showUserPopup}
                isBadgeClickable={!user.isHidden}
                notification={hasNotification && <div className={classes.notification} />}
                className={cn(classes.userBadgeAction, { [classes.disabled]: isDisabled })}
            />
            {children}
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        row: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
        },
        userBadgeAction: {
            flex: 1,
            paddingRight: 10,
        },
        disabled: {
            opacity: 0.6,
        },
        notification: {
            width: 10,
            height: 10,
            borderRadius: '50%',
            position: 'absolute',
            top: 2,
            right: -14,
            backgroundColor: '#EB5757',
        },
    }),
    { classNamePrefix: 'meetings-user-badge-item' }
);

export default UserBadgeAction;
